// Funzioni native dell'app Android (suoni notifiche, notifica di prova, widget Home).
// Con un APK vecchio il plugin non esiste: tutto resta funzionante, senza queste opzioni.
import { Capacitor, registerPlugin } from '@capacitor/core';

const AcademyNative = registerPlugin('AcademyNative');

export const SUONI_NOTIFICHE = [
  { id: 'academy', nome: 'Academy', descrizione: 'Arpeggio elegante' },
  { id: 'campanella', nome: 'Campanella', descrizione: 'Due rintocchi' },
  { id: 'arpa', nome: 'Arpa', descrizione: 'Glissato dolce' },
  { id: 'gocce', nome: 'Gocce', descrizione: 'Breve e discreto' },
  { id: 'cristallo', nome: 'Cristallo', descrizione: 'Accordo luminoso' },
  { id: 'sistema', nome: 'Suono del telefono', descrizione: 'Quello predefinito di Android' }
];

export function funzioniNativeDisponibili() {
  try {
    return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android' && Capacitor.isPluginAvailable('AcademyNative');
  } catch {
    return false;
  }
}

let audioWeb = null;
export async function ascoltaSuono(suono) {
  if (funzioniNativeDisponibili()) {
    try { await AcademyNative.anteprimaSuono({ suono }); return true; } catch { return false; }
  }
  if (suono === 'sistema') return false;
  try {
    if (audioWeb) audioWeb.pause();
    audioWeb = new Audio(`/suoni/suono_${suono}.wav`);
    await audioWeb.play();
    return true;
  } catch {
    return false;
  }
}

export async function statoNotificheNative() {
  if (!funzioniNativeDisponibili()) return null;
  try { return (await AcademyNative.statoNotifiche()).attive; } catch { return null; }
}

export async function apriImpostazioniNotificheNative() {
  if (!funzioniNativeDisponibili()) return;
  try { await AcademyNative.apriImpostazioniNotifiche(); } catch { /* niente */ }
}

export async function inviaNotificaProvaNativa(suono) {
  return AcademyNative.notificaProva({ suono, titolo: '🔔 Notifica di prova', testo: 'Perfetto! Le notifiche Academy Of Arts arrivano con questo suono.' });
}

export async function chiediWidgetHome() {
  if (!funzioniNativeDisponibili()) return false;
  try { return Boolean((await AcademyNative.aggiungiWidget()).richiesto); } catch { return false; }
}

// Invia al widget i dati aggiornati (solo se cambiati, al massimo una volta ogni pochi secondi).
let ultimiDatiWidget = '';
let attesaWidget = null;
export function aggiornaWidgetHome(dati) {
  if (!funzioniNativeDisponibili()) return;
  const chiave = JSON.stringify(dati);
  if (chiave === ultimiDatiWidget) return;
  ultimiDatiWidget = chiave;
  clearTimeout(attesaWidget);
  attesaWidget = setTimeout(() => {
    const adesso = new Date();
    const aggiornato = `${String(adesso.getDate()).padStart(2, '0')}/${String(adesso.getMonth() + 1).padStart(2, '0')} ${String(adesso.getHours()).padStart(2, '0')}:${String(adesso.getMinutes()).padStart(2, '0')}`;
    AcademyNative.aggiornaWidget({ ...dati, aggiornato }).catch(() => { ultimiDatiWidget = ''; });
  }, 1500);
}

// Il widget può aprire l'app direttamente su una pagina (Prenota, Avvisi, Presenze, Eventi).
export function ascoltaPagineDaWidget(apriPagina) {
  if (!funzioniNativeDisponibili()) return () => {};
  let gestore = null;
  let chiuso = false;
  AcademyNative.prendiPaginaRichiesta().then(risposta => { if (!chiuso && risposta?.pagina) apriPagina(risposta.pagina); }).catch(() => {});
  AcademyNative.addListener('paginaRichiesta', evento => { if (evento?.pagina) apriPagina(evento.pagina); }).then(g => { gestore = g; if (chiuso) g.remove(); }).catch(() => {});
  return () => { chiuso = true; gestore?.remove(); };
}

// Link academyofarts://accesso?codice=... aperto dalla vecchia icona: entra senza ridigitare i dati.
const codiciGiaUsati = new Set();
export function ascoltaCodiceAccesso(onCodice) {
  if (!funzioniNativeDisponibili()) return () => {};
  let gestore = null;
  let chiuso = false;
  const consegna = codice => {
    if (chiuso || !codice || codiciGiaUsati.has(codice)) return;
    codiciGiaUsati.add(codice);
    onCodice(codice);
  };
  AcademyNative.prendiCodiceAccesso().then(risposta => consegna(risposta?.codice)).catch(() => {});
  AcademyNative.addListener('codiceAccesso', evento => consegna(evento?.codice)).then(g => { gestore = g; if (chiuso) g.remove(); }).catch(() => {});
  return () => { chiuso = true; gestore?.remove(); };
}
